import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { makeEntityChildrenIdsSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  const entityChildrenIdsSelector = makeEntityChildrenIdsSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    return {
      ...props,

      hasReport: !!entityChildrenIdsSelector(state, props).length
    };
  };
};
export default connectCustom(makeMapStateToProps)(Component);
